import type { ComponentProps } from 'react'
import dynamic from 'next/dynamic'
import MountOnFirstOpen from 'src/components/MountOnFirstOpen'
import type ContactModalComponent from './ContactModal'

const ContactModal = dynamic(() => import('./ContactModal'), { ssr: false })

/** Load the form on demand, then retain its state across subsequent openings. */
const DeferredContactModal = (props: ComponentProps<typeof ContactModalComponent>) =>
  <MountOnFirstOpen open={props.open}>
    <ContactModal {...props} />
  </MountOnFirstOpen>

export default DeferredContactModal
